import { supabase } from '@/lib/supabase';
import { invokeRunFlowRuntime } from '@/lib/runtime-worker-client';
import type { AppRecord } from '@/lib/app-records';

/**
 * F6: « Relancer l'analyse » of an app object: the tool runs again on the
 * inputs of the object's last run, and its result updates that same object
 * (people's corrections stay). run-flow checks the object belongs to the app.
 */
export const rerunAppRecord = async (flowId: string, record: Pick<AppRecord, 'id' | 'lastRunId'>): Promise<string> => {
  if (!record.lastRunId) throw new Error('Cet objet n’a pas d’analyse à relancer.');
  const { data, error } = await supabase.from('flow_executions').select('input_values').eq('id', record.lastRunId).maybeSingle();
  if (error || !data?.input_values) throw new Error('Les entrées de la dernière analyse ne sont pas lisibles.');
  const response = await invokeRunFlowRuntime({ flowId, inputValues: data.input_values as Record<string, unknown>, appRecordId: record.id });
  const executionId = (response as { executionId?: unknown } | null)?.executionId;
  if (typeof executionId !== 'string') throw new Error('L’analyse n’a pas pu être relancée.');
  return executionId;
};

/** From the chat: the object is read again (its last run may have changed since the proposal). */
export const rerunAppRecordById = async (flowId: string, recordId: string): Promise<string> => {
  const { data, error } = await supabase.from('app_records').select('id, last_run_id').eq('id', recordId).maybeSingle();
  if (error || !data) throw new Error('Cet objet est introuvable ou inaccessible.');
  return rerunAppRecord(flowId, { id: data.id as string, lastRunId: (data.last_run_id as string | null) ?? null });
};
